import classnames from "classnames";
import type { TableBodyProps } from "./interfaces";

export const TableBody = ({ className, children, ...rest }: TableBodyProps) => (
  <tbody className={classnames("divide-primary divide-y", className)} {...rest}>
    {children}
  </tbody>
);
